import React, { useState } from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { api } from '@/lib/api';

interface SetupPageProps {
  email?: string;
  onComplete: () => void;
}

export function SetupPage({ email, onComplete }: SetupPageProps) {
  const [officeName, setOfficeName] = useState('');
  const [ownerName, setOwnerName] = useState('');
  const [ownerEmail, setOwnerEmail] = useState(email ?? '');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);

    try {
      await api.post('/auth/setup', { officeName, ownerName, ownerEmail });
      onComplete();
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Κάτι πήγε στραβά';
      setError(message);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="flex items-center justify-center min-h-screen bg-background p-6">
      <Card className="w-full max-w-md rounded-[22px] border-border shadow-lifted-lg">
        <CardHeader className="text-center">
          <img src="/logo-192.png" alt="Taxistry" className="w-14 h-14 mx-auto mb-3 rounded-2xl shadow-lifted" />
          <CardTitle className="font-display">Ρύθμιση Γραφείου</CardTitle>
          <CardDescription>
            Δημιουργήστε το λογιστικό σας γραφείο για να ξεκινήσετε.
          </CardDescription>
        </CardHeader>
        <form onSubmit={handleSubmit}>
          <CardContent className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="officeName" className="text-xs font-bold text-muted-foreground">Επωνυμία Γραφείου</Label>
              <Input
                id="officeName"
                value={officeName}
                onChange={(e) => setOfficeName(e.target.value)}
                placeholder="π.χ. Λογιστικό Γραφείο Παπαδόπουλος"
                required
                className="rounded-[10px] bg-surface-2"
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="ownerName" className="text-xs font-bold text-muted-foreground">Ονοματεπώνυμο</Label>
              <Input
                id="ownerName"
                value={ownerName}
                onChange={(e) => setOwnerName(e.target.value)}
                placeholder="π.χ. Γιάννης Παπαδόπουλος"
                required
                className="rounded-[10px] bg-surface-2"
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="ownerEmail" className="text-xs font-bold text-muted-foreground">Ηλ. Ταχυδρομείο</Label>
              <Input
                id="ownerEmail"
                type="email"
                value={ownerEmail}
                onChange={(e) => setOwnerEmail(e.target.value)}
                required
                className="rounded-[10px] bg-surface-2"
              />
            </div>
            {error ? (
              <p className="text-sm text-destructive">{error}</p>
            ) : null}
          </CardContent>
          <CardFooter>
            <Button type="submit" className="w-full gradient-primary text-white rounded-[12px]" disabled={submitting}>
              {submitting ? 'Δημιουργία...' : 'Δημιουργία Γραφείου'}
            </Button>
          </CardFooter>
        </form>
      </Card>
    </div>
  );
}
